import React, {
	Component
} from 'react';
import styled from 'styled-components';

const HiddenAssets = styled.div`
	overflow: hidden;
	top: 0px;
	left: 0px;
	height: 1px;
	width: 1px;
	z-index: -1000;
`

export class PreloadAssets extends Component {

	shouldComponentUpdate(){
		return false;
	}

	render(){
		return (
			<HiddenAssets>
				{this.props.children}
			</HiddenAssets>
		);
	}
}